import './styles/item-details.scss'

import React       from 'react'
import PropTypes   from 'prop-types'
import { connect } from 'react-redux'
import classnames  from 'classnames'

import metadata  from '../redux/metadata'
import api from '../redux/api'
import Loading from './Loading'
import { mapCategoryPaths } from '../routeUtils'

function getItemId({ category, id }) {
  return `${category}:${id}`
}

function getPathCategory(props) {
  const { categories } = props
  const { categoryPath } = props.match.params

  const categoryPaths = mapCategoryPaths(categories)
  const category = Object.keys(categoryPaths).find((category) => categoryPaths[category] === categoryPath)

  return category
}

class ItemDetails extends React.Component {
  static propTypes = {
    data:       PropTypes.object.isRequired,
    match:      PropTypes.object.isRequired,
    history:    PropTypes.object.isRequired,
    categories: PropTypes.array.isRequired,
  }

  state = {
    initted: false,
    loading: false,
  }

  constructor(props) {
    super(props)
    this.handlePropChange(props)
  }

  componentDidMount() {
    this.setState({ initted: false }, () => {
      setTimeout(() => {
        this.setState({ initted: true })
      }, 0)
    })
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.handlePropChange(props)
  }

  handlePropChange(props) {    
    const { data } = this.state

    if (!data || getItemId(props.match.params) !== getItemId(this.props.match.params)) {
      const { id } = props.match.params

      const category = getPathCategory(props)

      api.loadDataItem(category, id).then((data) => {
        this.setState({ data })
      })
    }
  }

  renderNoData = () => {
    return (
      <div className="item-details">
        <Loading />
      </div>
    )
  }

  handleLink = (linkedItem, category) => {
    this.props.history.push(`/category/${category}/item/${linkedItem.id}`)
  }

  render() {
    const { data }    = this.props
    const { initted } = this.state
    const item        = this.state.data

    if (!item) {
      return this.renderNoData()
    }

    const category = getPathCategory(this.props)

    const categoryMetadata = metadata[category]
    const title            = categoryMetadata.name(item)
    const description      = categoryMetadata.description && categoryMetadata.description(item)
    const properties       = categoryMetadata.properties || []

    const className = classnames('item-details', { initted })

    return (
      <div className={className}>
        <h1>{ title }</h1>

        {
          description && <div>{ description } </div>
        }

        {
          properties.length > 0 && (
            <div className="properties">
              {
                properties.map(({ linkTo, propName, label }, index) => {
                  const prop = item[propName]

                    if (prop && linkTo) {
                      const key      = item[propName]
                      const category = linkTo.category

                      const linkedCategoryItems = data[category]
                      const linkedItem          = linkedCategoryItems.find((linkedCategoryItem) => {
                          return linkedCategoryItem[linkTo.destinationPropName] === key
                      })
                      const linkedItemTitle = metadata[category].name(linkedItem)

                      const handleLink = (event) => {
                          event.preventDefault()
                          this.handleLink(linkedItem, category)
                      }
                      return (
                          <div className="property" key={index}>
                              <div className="prop-name">{ label }</div>
                              <a href="/" key={index} onClick={handleLink}>{ linkedItemTitle }</a>
                          </div>
                      )
                    }
                  
                  return prop && (
                    <div className="property" key={index}>
                      <div className="prop-name">{ label }</div>
                      <div className="prop-value">{ prop }</div>
                    </div>
                  )
                })
              }
            </div>  
          )
        }
      </div>
    )
  }
}

const mapDispatchToProps = {}
const mapStateToProps = (state) => ({
  data:       state.items.data,
  categories: state.items.categories,
})

export default connect(mapStateToProps, mapDispatchToProps)(ItemDetails)